import { API_URL } from "config";
import Http from "util/https";
import { CompanySelectParams, CompanyListInfo, CompanySelectResponse } from "../types";
import { checkHalfKanaOnly } from "../utils/common";

/**
 * ジョイフル用設定画面用・登録企業絞込検索API
 * @param params 企業絞込検索リクエストパラメータ
 * @returns {CompanyListInfo[]} レスポンスステータスコード
 */
const companySelectApi = async (
  params: CompanySelectParams,
): Promise<{
  total: number;
  list: CompanyListInfo[];
}> => {
  console.log('companySelectApi params:', params);

  const http = Http.default.alterAuth({ useToken: true });
  const url = `${API_URL}/joyful/company/select`;
  const res = await http.post<CompanySelectResponse>(url, params);
  console.log(res);

  return {
    total: res.data.total,
    list: res.data.company_list.map(c => ({
      company_cd: c.company_cd ?? '',
      company_name: c.company_name ?? '',
      center_cd: c.center_cd ?? '',
      stores: c.stores.map(s => ({
        client_cd: s.client_cd,
        client_store_cd: s.client_store_cd,
        client_store_name: checkHalfKanaOnly(s.client_store_name) ? s.client_store_name : "",
        client_store_temp: s.client_store_name, // 企業編集の店舗名表示に使用
      })),
    })),
  };
};

export default companySelectApi;
